// 证书
const certificateRouter =
[
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('@/views/certificate/index.vue'),
    meta: {
      title: '证书查询系统'
    }
  },
  {
    path: '/myCertificate',
    name: 'MyCertificate',
    component: () => import('@/views/certificate/myCertificate.vue'),
    meta: {
      title: '我的证书'
    }
  }
]
// {
//   path: '/certificate',
//   name: 'certificate',
//   // redirect: '/archive/',
//   component: () => import('@/views/certificate/index.vue'),
//   children: [
//     {
//       path: '/',
//       name: 'certificate1',
//       meta: {
//         title: '证书查询'
//         // type: 'login'
//       },
//       component: () => import('@/views/certificate/index.vue')
//     }
//   ]
// }
export default certificateRouter
